import React from 'react';
import PropTypes from 'prop-types';
export const Compose = ({ components, children }) => (React.createElement("div", null, components.reduceRight((next, Comp) => (React.createElement(Comp, null, next)), children)));
Compose.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    components: PropTypes.array,
    children: PropTypes.node.isRequired,
};
Compose.defaultProps = {
    components: [],
};
